import { Box, CircularProgress } from '@mui/material';

import { InsuranceCardUploadSection } from '../documentUpload';
import { LOADING_OVERLAY_SX } from '../styles';

import type { InsuranceCardFieldsSectionProps } from './types';

export default function InsuranceCardFieldsSection({
  isExtracting,
  backFileName,
  backFileType,
  backPreviewLoading,
  backPreviewUrl,
  backUploadButtonLabel,
  disabled,
  frontFileName,
  frontFileType,
  frontPreviewLoading,
  frontPreviewUrl,
  frontUploadButtonLabel,
  insuranceType,
  showHelperText,
  showRequiredError,
  onUploadBack,
  onUploadFront,
}: InsuranceCardFieldsSectionProps) {
  return (
    <Box sx={{ position: 'relative' }}>
      {isExtracting ? (
        <Box sx={LOADING_OVERLAY_SX}>
          <CircularProgress size={32} />
        </Box>
      ) : null}
      <InsuranceCardUploadSection
        backFileName={backFileName}
        backFileType={backFileType}
        backPreviewLoading={backPreviewLoading}
        backPreviewUrl={backPreviewUrl}
        backUploadButtonLabel={backUploadButtonLabel}
        disabled={disabled}
        frontFileName={frontFileName}
        frontFileType={frontFileType}
        frontPreviewLoading={frontPreviewLoading}
        frontPreviewUrl={frontPreviewUrl}
        frontUploadButtonLabel={frontUploadButtonLabel}
        insuranceType={insuranceType}
        onUploadBack={onUploadBack}
        onUploadFront={onUploadFront}
        showHelperText={showHelperText}
        showRequiredError={showRequiredError}
      />
    </Box>
  );
}
